import { alpha, createStyles, makeStyles, Theme } from '@material-ui/core';
import commonStyles from 'config/commonStyles';

const styles = makeStyles((theme: Theme) =>
    createStyles({
        ...commonStyles,
        mainContainer: {
            height: '100%',
            maxHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        tab: {
            padding: '0 10px 0 20px',
            '& .MuiTab-wrapper': {
                letterSpacing: 1.25,
            },
            '& .MuiTab-root': {
                padding: '6px 10px',
            },
            '& .MuiTabScrollButton-root:first-child': {
                marginLeft: -10,
                width: 10,
            },
            '& .MuiTabScrollButton-root.Mui-disabled': {
                opacity: 0.3,
            },
        },
        noPadding: {
            padding: '0',
        },
        activeTab: {
            color: theme.palette.primary.main,
        },
        tabButtons: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginRight: 5,
            '& button': {
                margin: '0 5px',
            },
        },
        sectionContainer: {
            position: 'relative',
            height: 'inherit',
            maxHeight: 'calc(100% - 50px)',
            borderRadius: '4px',
        },
        container: {
            height: '100%',
            display: 'flex',
            '& .MuiFilledInput-multiline': {
                height: 135,
            },
            '& .MuiFilledInput-inputMultiline': {
                height: '100%',
            },
        },
        restaurantDetailsLeftContainer: {
            flex: 6,
            padding: '15px 20px',
            borderRight: '1px solid #E5E5E5',
            overflowY: 'auto',
            '@media (max-width: 1440px)': {
                maxWidth: 600,
            },
        },
        restaurantDetailsRightContainer: {
            flex: 6,
            padding: '5px 15px',
            overflow: 'auto',
            // maxHeight: '90%',
            backgroundColor: alpha(theme.palette.secondary.light, 0.3),
        },
        flexRowContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        logoContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginLeft: '13.5%',
            marginBottom: '-5%',
        },
        foodLogo: {
            width: '96px',
            height: '96px',
            borderRadius: '48px',
        },
        restaurantImage: {
            width: '348px',
            height: '158px',
            objectFit: 'cover',
        },
        uploadLogoTextContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignSelf: 'center',
            width: '160px',
            marginTop: '10px',
            marginLeft: '-8px',
            zIndex: 1,
        },
        uploadLogoText: {
            fontWeight: '500',
            color: theme.palette.primary.main,
            cursor: 'pointer',
            marginTop: 20,
            fontSize: 14,
        },
        restaurantPhotoContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '48%',
            height: '158px',
            borderRadius: '4px',
            border: `1px solid ${theme.palette.grey['300']}`,
            position: 'relative',
        },
        uploadPhotoContainer: {
            height: 43,
            width: 43,
            backgroundColor: theme.palette.background.default,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 4,
        },
        removePhotoContainer: {
            ...commonStyles.imageContainerCenter,
            backgroundSize: 'cover',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            width: '100%',
            '& > div': {
                height: 43,
                width: 43,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 4,
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                cursor: 'pointer',
            },
        },
        formContainer: {
            width: '100%',
        },
        formInput: {
            marginBottom: '4%',
            width: '48%',
        },
        halfFormInputContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '48%',
            marginBottom: '4%',
        },
        halfFormInput: {
            width: '48%',
        },
        serviceSectionContainer: {
            display: 'flex',
            alignItems: 'center',
            marginTop: '4%',
        },
        basicServiceSectionContainer: {
            display: 'flex',
            alignItems: 'center',
            marginTop: '4%',
        },
        serviceSectionTitle: {
            width: '10%',
        },
        divider: {
            width: '150px',
            marginRight: '20px',
        },
        divider70px: {
            width: '70px',
        },
        halfDivider: {
            width: '55%',
            marginRight: '1%',
        },
        homeDeliveryIcon: {
            width: '35px',
            height: 32,
        },
        takeAwayIcon: {
            width: '29px',
            height: 32,
            marginLeft: '2px',
        },
        dineInIcon: {
            width: 32,
            height: 32,
        },
        takeOutIcon: {
            width: 32,
            height: 32,
            fill: 'none',
            transform: 'scale(1.5)',
        },
        spinner: {
            marginLeft: '50%',
            marginTop: '28%',
        },
        categoriesContainer: {
            padding: '15px 0',
            //height: '680px',
            maxHeight: 'calc(100% - 50px)',
            overflow: 'auto',
            // '& .MuiTableCell-paddingNone div': {
            //     width: '100%',
            // },
            '& table thead tr th, & table tbody tr:first-child td': {
                border: 'none',
            },
        },
        tableHead: {
            color: theme.palette.secondary.main,
            fontSize: '14px',
            fontWeight: '500',
        },
        test: {
            width: '100%',
            backgroundColor: theme.palette.secondary.main,
        },
        hourText: {
            fontSize: '14px',
            fontWeight: 500,
            color: theme.palette.primary.main,
        },
        workingHoursContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginRight: '3%',
            width: '30%',
        },
        dayContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '12%',
            height: '35px',
            color: theme.palette.secondary.main,
            backgroundColor: theme.palette.secondary.light,
            borderRadius: '3px',
            '&:hover': {
                color: theme.palette.common.white,
                cursor: 'pointer',
                backgroundColor: theme.palette.primary.main,
            },
        },
        selectedDayContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '12%',
            height: '35px',
            color: theme.palette.common.white,
            backgroundColor: theme.palette.primary.main,
            borderRadius: '3px',
            '&:hover': {
                color: theme.palette.common.white,
                cursor: 'pointer',
            },
        },
        checkboxContainer: {
            display: 'flex',
            alignSelf: 'flex-start',
            alignItems: 'center',
        },
        root: {
            '& .MuiTableCell-head': {
                color: 'rgba(158, 158, 158, 1)',
                paddingTop: 16,
            },
            '& .MuiListItem-gutters': {
                padding: '0',
            },
            '& .MuiPaper-root': {
                width: 1115,
            },
            '& .MuiToolbar-root': {
                paddingRight: 30,
                paddingLeft: 16,
                minHeight: 40,
                fontSize: 16,
            },
            '& .MuiTypography-root': {
                fontSize: 16,
            },
            '& .MuiCheckbox-root': {
                padding: 0,
            },
            //height: 725,
        },
        contactsTable: {
            minWidth: 650,
            '& th:first-child': {
                width: 10,
            },
            '& tr td:last-child': {
                padding: '0 15px 0 0',
            },
            '& .MuiTableCell-paddingNone': {
                padding: '0 !important',
            },
            overflow: 'auto',
        },
        dots: {
            '&:hover': {
                cursor: 'pointer',
            },
        },
        toolbarTitle: {
            flex: '1 1 100%',
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
            maxWidth: 300,
            '& .MuiSelect-select:focus': {
                backgroundColor: 'transparent',
            },
        },
        chips: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        chip: {
            margin: 2,
        },
        noLabel: {
            marginTop: theme.spacing(3),
        },
        dialog: {
            '& .MuiDialogTitle-root > h2': {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            },
        },
        tableHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: 16,
        },
        makePhotoMainCheckbox: {
            width: '48%',
        },
        currencyText: {
            color: theme.palette.primary.main,
            fontWeight: '400',
            fontSize: '14px',
            marginTop: '6px',
            marginRight: '2px',
        },
        currencyAmount: {
            color: theme.palette.primary.main,
            fontWeight: '700',
            fontSize: '24px',
        },
        bottomLine: {
            padding: '3px 0',
            borderBottom: `1px solid ${theme.palette.grey['300']}`,
        },
        listBox: {
            marginTop: 0,
            padding: 0,
        },
        paper: {
            marginTop: 0,
        },
        dropdownItem: {
            padding: 0,
            '&:hover': {
                cursor: 'pointer',
                backgroundColor: alpha(theme.palette.primary.main, 0.16),
            },
        },
        selectedDropdownItem: {
            backgroundColor: alpha(theme.palette.primary.main, 0.16),
        },
        closedText: {
            color: alpha(theme.palette.common.black, 0.6),
            marginBottom: '2px',
            fontSize: '14px',
        },
        cancelButton: {
            marginRight: '15px!important',
        },
        serviceText: {
            width: '160px',
        },
        financeTabText: {
            fontSize: '20px',
            fontWeight: '500',
            color: theme.palette.common.black,
        },
        saveChangesButton: {
            /* height: '75%',
            width: 171, */
            position: 'absolute',
            right: 10,
            top: 6,
        },
        advancedSettingsSaveButton: {
            position: 'absolute',
            top: 6,
            right: 10,
        },
        dishesSelect: {
            '& .MuiInputAdornment-root.MuiInputAdornment-positionStart.MuiInputAdornment-filled': {
                margin: 0,
            },
        },
        coffeeCupIcon: {
            marginRight: 10,
            height: 20,
            width: 20,
            borderRadius: 50,
            backgroundColor: theme.palette.common.white,
            backgroundPosition: 'center',
            backgroundSize: 'auto',
            backgroundRepeat: 'no-repeat',
        },
        threeDotsMenuDisabledCell: {
            borderBottomColor: 'rgba(224, 224, 224, 0.35)',
        },
        disabledRow: {
            opacity: 0.3,
        },
        servicesContainer: {
            borderWidth: 1,
            borderColor: '#99567E',
        },
        servicesDayRowsContainer: {
            overflowY: 'auto',
            overflowX: 'hidden',
        },
        servicesTopContainer: {
            flexDirection: 'row',
            display: 'flex',
        },
        serviceTopLeft: {
            display: 'flex',
            width: 40,
            backgroundColor: '#fff',
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
            color: '#0000',
            marginRight: 8,
        },
        seviceTopColumnContainer: {
            display: 'flex',
            flexDirection: 'column',
            // height: 200,
            paddingTop: 16,
            width: 168,
            alignItems: 'center',
            // justifyContent: 'space-between',
            border: '1px solid #99567E',
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
            borderBottomWidth: 0,
            backgroundColor: '#fff',
            position: 'relative',
            '&:not(:last-child)': {
                marginRight: 8,
            },
        },
        serviceIconContainer: {
            display: 'flex',
            flexDirection: 'column',
            position: 'absolute',
            right: 4,
            top: 4,
            zIndex: 9,
            fontSize: 24,
        },
        takeoutInfoIcon: {
            marginTop: 8,
        },
        serviceDayRowContainer: {
            display: 'flex',
            flexDirection: 'row',
        },
        serviceRowDayName: {
            display: 'flex',
            width: 40,
            backgroundColor: '#fff',
            textAlign: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: 8,
        },
        hoursContainer: {
            height: '100%',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
        },
        serviceHours: {
            width: '100%',
            fontWeight: 500,
            backgroundColor: 'transparent !important',
            fontSize: 16,
            display: 'flex',
            '&:hover': {
                color: theme.palette.primary.dark,
                textDecoration: 'underline',
            },
            '& .MuiButton-label': {
                flexDirection: 'column',
                lineHeight: 1.2,
            },
        },
        serviceHoursActive: {
            color: theme.palette.primary.main,
        },
        addHoursButtons: {
            marginTop: 16,
            marginBottom: 16,
        },
        serviceNameContainer: {
            fontSize: 10,
            textAlign: 'center',
            margin: theme.spacing(1, 0),
        },
        termsEditIcon: {
            position: 'absolute',
            height: 24,
            top: 16,
            right: 16,
        },
        termsEditIconSmall: {
            top: 8,
            right: 8,
            transform: 'scale(0.75)',
        },
        tableBody: {
            height: '100%',
            overflowY: 'auto',
            maxHeight: 400,
        },
        paperKeyContainer: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            padding: theme.spacing(2),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: theme.spacing(1),
        },
        apiKeyText: {
            fontFamily: 'monospace',
            wordBreak: 'break-all',
            flex: 1,
        },
        dialogActions: {
            paddingRight: theme.spacing(3),
            marginBottom: 0,
        },
        titleRoot: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        serviceToggleWrapper: {
            border: `1px solid ${theme.palette.grey[500]}`,
            borderRadius: 4,
            overflow: 'hidden',
            backgroundColor: '#f5f5f5',
        },
        serviceToggleRow: {
            padding: theme.spacing(1),
        },
        serviceToggleRowDivided: {
            borderBottom: `1px solid ${theme.palette.grey[500]}`,
        },
        serviceActions: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
        },
        additionalServiceContainer: {
            margin: theme.spacing(2, 1),
        },
        servicesConfigurationHintContainer: {
            margin: theme.spacing(2, 0, 1, 0),
            padding: theme.spacing(2),
            border: `1px solid ${theme.palette.primary.main}`,
            borderRadius: 4,
            verticalAlign: 'center',
        },
        serviceAdditionalSettingsImageContainer: {
            width: 24,
            height: 24,
            borderRadius: 8,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        serviceDeliveryAniTimeImage: {
            width: '100%',
            aspectRatio: 1.1,
        },
        servicePayToCloseTimeImage: {
            width: '100%',
            aspectRatio: 4 / 3,
        },
    })
);

export default styles;
